// removed by extract-text-webpack-plugin
module.exports = {"table":"src-components-DayPage-__EventTable-module___table","row":"src-components-DayPage-__EventTable-module___row","sun":"src-components-DayPage-__EventTable-module___sun","type":"src-components-DayPage-__EventTable-module___type","icon":"src-components-DayPage-__EventTable-module___icon","title":"src-components-DayPage-__EventTable-module___title","info":"src-components-DayPage-__EventTable-module___info","time":"src-components-DayPage-__EventTable-module___time"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DayPage/EventTable.module.css
// module id = 1342
// module chunks = 0